// Real customer quotes only, added with permission. Leave empty until you have some.
// Shape for each entry: { quote, name, context }
// Example: { quote: "Showed up on time and explained everything before he started.", name: "Sarah M.", context: "Window cleaning, North Boise" }

const testimonials = [];

export default testimonials;
